import * as React from "react"
import {Navigate} from "react-router-dom";

import {SHARE_OF_SEARCH_ROUTES} from "@constants"
import AppLayout from "Layout"
import ShareOfSearchKpiPage from "./Kpi";
import ShareOfSearchPage from "./Details";
import ShareOfSearchStatusPage from "./Status";


export const ShareOfSearchRoutes = {
    path: SHARE_OF_SEARCH_ROUTES.PATH,
    title: SHARE_OF_SEARCH_ROUTES.TITLE,
    accessKey: SHARE_OF_SEARCH_ROUTES.ACCESS_KEY,
    icon: 'globe-pointer',
    description: "Analyze Your Brand’s Visibility and Search Performance in the Market",
    element: <AppLayout />,
    children: [{
        element: <Navigate to={SHARE_OF_SEARCH_ROUTES.SHARE_PATH} replace />,  index: true
    }, {
        title: 'Share of Search KPIs',
        path: SHARE_OF_SEARCH_ROUTES.SHARE_PATH,
        dashboardKey: SHARE_OF_SEARCH_ROUTES.SHARE_ID,
        element: <ShareOfSearchKpiPage />
    }, {
        title: 'Share of Search Details',
        path: SHARE_OF_SEARCH_ROUTES.DETAILS_PATH,
        dashboardKey: SHARE_OF_SEARCH_ROUTES.DETAILS_ID,
        element: <ShareOfSearchPage />
    }, {
        title: 'Share of Search Status',
        path: SHARE_OF_SEARCH_ROUTES.STATUS_PATH,
        dashboardKey: SHARE_OF_SEARCH_ROUTES.STATUS_ID,
        element: <ShareOfSearchStatusPage />
    }]
}